import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import FormRow from "components/form/FormRow";
import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import Insumo from "entity/Insumo";
import { useEffect } from "react";
import { useForm } from "react-final-form";
import { numberToPtBrLocaleString } from "util/number";
import DCor from "..";
import Operador from "entity/Operador";

export default function DCorEditFields({ visita, TipoClass }) {
    const [tipo, setTipo] = useTipoApontamento();
    const params = visita.cliente.getParams(DCor, "Mecanizado", TipoClass);

    const [apontamento] = useFieldValue();
    const form = useForm();

    useEffect(() => {
        if (tipo !== "Mecanizado") {
            setTipo("Mecanizado");
        }
    }, [setTipo, tipo]);

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = DCor.calcConformidade(apontamento, params);
            form.change("conformidade", DCor.calcConformidade(apontamento, params));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} />

            <ApontamentoAmostraParams tipoFixedValue={"Mecanizado"}>
                <FormRow>
                    <EntitySearchInput name="insumo" label="Insumo" EntityClass={Insumo} required />
                </FormRow>
                <FormRow>
                    <TextInput type="number" name="dosagemRecomendada" label="Dosagem Recomendada" required />
                </FormRow>
                <FormRow>
                    <TextInput type="number" name="qtdBandejas" label="Quantidade de bandejas" required />
                </FormRow>
                <FormRow>
                    <EntitySearchInput
                        name="operador"
                        label="Operador"
                        EntityClass={Operador}
                        extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                    />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Intervalo:">
                            ({params.intervaloMin}, {params.intervaloMax})
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="Meta (%):">
                            {parseFloat(params.meta).toFixed(2)}
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="Área (ha)">
                            {numberToPtBrLocaleString(params.areaHa)}
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="Largura">
                            {parseFloat(params.largura).toFixed(2)}
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="Comprimento">
                            {parseFloat(params.comprimento).toFixed(2)}
                        </ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <FormRow>
                    <TextInput type="number" name="esquerda" label="Esquerda" />
                    <TextInput name="conformeEsq" label="Conforme Esquerda" disabled />
                </FormRow>

                <FormRow>
                    <TextInput type="number" name="centro" label="Centro" />
                    <TextInput name="conformeCen" label="Conforme Centro" disabled />
                </FormRow>

                <FormRow>
                    <TextInput type="number" name="direita" label="Direita" />
                    <TextInput name="conformeDir" label="Conforme Direita" disabled />
                </FormRow>
            </ApontamentoColetas>

            <ApontamentoResultado />
            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
